const sections = new WeakMap();

function setupCollectionListScrollbar(section) {
  if (sections.has(section)) return;

  const scroller = section.querySelector('slideshow-slides[ref="scroller"]');
  const track = section.querySelector('[data-collection-list-scrollbar]');
  const thumb = section.querySelector('[data-collection-list-scrollbar-thumb]');

  if (!scroller || !track || !thumb) return;

  let frame = 0;

  const update = () => {
    frame = 0;

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;

    if (maxScroll <= 1) {
      track.hidden = true;
      return;
    }

    track.hidden = false;

    const trackWidth = track.clientWidth;
    const visibleRatio = scroller.clientWidth / scroller.scrollWidth;
    const thumbWidth = Math.max(trackWidth * visibleRatio, 40);
    const travel = Math.max(trackWidth - thumbWidth, 0);
    const progress = scroller.scrollLeft / maxScroll;

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translateX(${progress * travel}px)`;
  };

  const requestUpdate = () => {
    if (frame) return;
    frame = requestAnimationFrame(update);
  };

  const resizeObserver = new ResizeObserver(requestUpdate);
  resizeObserver.observe(scroller);
  resizeObserver.observe(track);

  scroller.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  requestUpdate();

  sections.set(section, {
    destroy() {
      if (frame) cancelAnimationFrame(frame);
      resizeObserver.disconnect();
      scroller.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
    },
  });
}

function initCollectionListScrollbars(root = document) {
  if (root.matches?.('.collection-list-section--editorial-carousel')) {
    setupCollectionListScrollbar(root);
  }

  root.querySelectorAll('.collection-list-section--editorial-carousel').forEach(setupCollectionListScrollbar);
}

initCollectionListScrollbars();

document.addEventListener('shopify:section:load', (event) => {
  initCollectionListScrollbars(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  if (event.target.matches?.('.collection-list-section--editorial-carousel')) {
    sections.get(event.target)?.destroy();
    sections.delete(event.target);
  }

  event.target.querySelectorAll('.collection-list-section--editorial-carousel').forEach((section) => {
    sections.get(section)?.destroy();
    sections.delete(section);
  });
});
